/**
 * Factory for WebSked editions
 * @author Umer Hassan, Brendan Magee
 */

function EditionFactory(
  $http,
  $q,
  $translate,
  toastWrapperService,
  analyticsService,
  Story
) {
  class Edition {
    constructor(data = {}) {
      const editionData = data;

      if (data.stories && data.stories.length) {
        editionData.stories = data.stories.map(story => new Story(story));
      }

      editionData.publicationTime *= 1000;

      Object.assign(this, Edition.defaultProperties, editionData);
    }

    static get defaultProperties() {
      return {
        id: null,
        publicationId: null,
        publicationTime: null,
        closed: null,
        finalized: null,
        note: '',
        storyIds: [],
        stories: []
      };
    }

    static get(editionId) {
      return $http.get(`api/editions/${editionId}`)
        .then(response => new Edition(response.data));
    }

    toggleClose() {
      this.closed = !this.closed;
      const desiredAction = this.closed ? 'close' : 'open';

      return $http.patch(`api/editions/${this.id}/${desiredAction}`)
        .then((response) => {
          analyticsService.trackEvent('Publication edition management', 'toggled edition close status');
          return new Edition(response.data);
        }, (error) => {
          this.closed = !this.closed;
          return $q.reject(error);
        });
    }

    updateOrder() {
      return $http.put(`api/editions/${this.id}`, this.payload)
        .then((response) => {
          analyticsService.trackEvent('Publication edition management', 'edition order updated');
          return new Edition(response.data);
        });
    }

    saveNote() {
      return $http.put(`api/editions/${this.id}`, this.payload)
        .then((response) => {
          analyticsService.trackEvent('Publication edition management', 'edition note saved');
          return new Edition(response.data);
        });
    }

    toggleLock() {
      this.finalized = !this.finalized;

      if (this.finalized && !this.closed) {
        this.closed = true;
      }

      return $http.put(`api/editions/${this.id}`, this.payload)
        .then((response) => {
          analyticsService.trackEvent('Publication edition management', 'edition finalize toggle');
          return new Edition(response.data);
        }, (error) => {
          this.finalized = !this.finalized;
          return $q.reject(error);
        });
    }

    get payload() {
      const { moreAvailable, currentPage, stories, ...payload } = { ...this };

      if (payload.storyIds && Array.isArray(payload.storyIds) && payload.storyIds.length < 1) {
        payload.storyIds = null;
      }

      return payload;
    }
  }

  return Edition;
}

const factoryArray = [
  '$http',
  '$q',
  '$translate',
  'toastWrapperService',
  'analyticsService',
  'Story',
  EditionFactory
];

export default function (ngModule) {
  ngModule.factory('Edition', factoryArray);
}
